// Issue with watermelonDB library https://github.com/Nozbe/WatermelonDB/issues/629
// @ts-nocheck
import { Model, Q } from '@nozbe/watermelondb';
import {
    field,
    date,
    readonly,
    relation,
    lazy,
} from '@nozbe/watermelondb/decorators';
import { setGenerator } from '@nozbe/watermelondb/utils/common/randomId';
import { v4 as uuidv4 } from 'uuid';
import { ShoppingListModel } from '../../types/ShoppingList';
import { ShoppingListProductSimple } from './ShoppingListProduct';

setGenerator(uuidv4);

export default class ShoppingList extends Model {
    static table = 'shopping_lists';

    static associations = {
        shopping_list_products: {
            type: 'has_many',
            foreignKey: 'shopping_list_id',
        },
        users: { type: 'belongs_to', key: 'user_id' },
        organisations: { type: 'belongs_to', key: 'organisation_id' },
    };

    @relation('users', 'user_id') user;
    @relation('organisations', 'organisation_id') organisation;
    @field('user_id') userId;
    @field('organisation_id') organisationId;
    @field('name') name;
    @field('added_to_inventory_time') addedToInventoryTime;
    @field('sent_to_dealer_time') sentToDealerTime;
    @field('requested_sending_to_dealer_time') requestedSendingToDealerTime;
    @field('dealer_id') dealerId;
    @date('created_at') createdAt;
    @date('updated_at') updatedAt;

    @lazy
    shoppingListProducts = this.collections
        .get('shopping_list_products')
        .query(Q.where('shopping_list_id', this.id));
}

export type ShoppingListSimple = {
    id: string;
    userId: string;
    organisationId: string;
    name: string;
    addedToInventoryTime: string;
    sentToDealerTime: string;
    requestedSendingToDealerTime: string;
    dealerId: string;
    createdAt: string;
    updatedAt: string;
} & ShoppingListRelations;

export type ShoppingListCreator = {
    id: string;
    firstName: string;
    lastName: string;
};

export type ShoppingListRelations = {
    shoppingListProducts?: ShoppingListProductSimple[];
    creator?: ShoppingListCreator | null;
    creatorColor?: string | null;
};

export const simplifyShoppingList = (
    shoppingList: ShoppingListModel,
    relations?: ShoppingListRelations,
): ShoppingListSimple => {
    return {
        id: shoppingList.id,
        userId: shoppingList.userId,
        organisationId: shoppingList.organisationId,
        name: shoppingList.name,
        addedToInventoryTime: shoppingList.addedToInventoryTime,
        sentToDealerTime: shoppingList.sentToDealerTime,
        requestedSendingToDealerTime: shoppingList.requestedSendingToDealerTime,
        dealerId: shoppingList.dealerId,
        createdAt: shoppingList.createdAt.toISOString(),
        updatedAt: shoppingList.updatedAt.toISOString(),
        ...relations,
    };
};
